import { Effect } from 'effect';

import { reactivityKeys } from '../reactivityKeys';
import { requestFavouriteListsWithProductCodes } from '../../request/backendApi/favourites/getFavouriteListsWithProductCodes';
import { RuntimeClientAtom } from '../../runtime/RuntimeClient';
import * as Atom from 'effect/unstable/reactivity/Atom';

export const getFavouriteListsWithProductCodesAtom = RuntimeClientAtom.atom(
  Effect.gen(function* () {
    const result = yield* requestFavouriteListsWithProductCodes;
    return result['hydra:member'];
  })
).pipe(Atom.withReactivity([reactivityKeys.favouriteLists]), Atom.keepAlive);
